import type { SVGProps } from 'react';

const SvgTimeLtFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 16 16' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <rect x={2} y={2} width={12} height={12} rx={6} fill='currentColor' stroke='#696D74' />
    <path d='M8 5V7.75C8 7.90738 8.0741 8.05557 8.2 8.15L10.4 9.8' stroke='#696D74' strokeLinecap='round' />
  </svg>
);
export default SvgTimeLtFilled;
